import React from "react";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import Card, { CardContent } from "material-ui/Card";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import classnames from "classnames";

import GetThumbnailResultView from "./getThumbnailResult";

class ThumbnailViewer extends React.Component {
  constructor(props) {
    super(props);
  }

  setSubtestView = e => {
    const { subtest, onChangeResultsViewer } = this.props;
    onChangeResultsViewer(subtest);
  };

  render() {
    const {
      classes,
      results,
      subtest,
      translate,
      pager,
      getSubtestResults,
      subtestResultsRemote,
      subtestResultsDisplay,
      subtestResultsWiremap,
      chartLineStyle,
      chartMeasurement,
      chartMeasurementUnit,
      wiremapStandard,
      showMargin,
      setPreferences,
      preferences,
      test,
      graphable,
      onChangeResultsViewer
    } = this.props;

    let View = GetThumbnailResultView(subtest);

    let status = "";
    let subtestRes;
    if (subtest === "Wiremap") {
      status = subtestResultsWiremap ? subtestResultsWiremap.Status : "";
    } else {
      if (subtest === "HeadRoom") {
        subtestRes = results.data.othersubtests.find(
          x => x.subtesttype === subtest
        );
      } else {
        subtestRes = results.data.lfttest.find(
          x => x.subtesttypeid === subtest
        );
      }
      if (subtestRes === undefined) {
        subtestRes = results.data.subtests.find(x => x.subtesttype === subtest);
      }
      if (subtestRes) {
        status = subtestRes.subteststatus;
      }
    }
    const tileBorderClass = status => {
      switch (status) {
        case "Pass":
          return classes.borderpassed;
        case "Fail":
          return classes.borderfailed;
        case "MarginalFail":
          return classes.borderfailed;
        case "MarginalPass":
          return classes.borderpassed;
        default:
          return classes.bordernotrun;
      }
    };
    return (
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
        <Card
          className={classnames(classes.cardCover, tileBorderClass(status))}
        >
          <CardContent className={classes.cardContent}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.content}
              >
                <View
                  thumbnailView
                  results={results}
                  subtest={subtest}
                  translate={translate}
                  pager={pager}
                  getSubtestResults={getSubtestResults}
                  subtestResultsRemote={subtestResultsRemote}
                  subtestResultsDisplay={subtestResultsDisplay}
                  subtestResultsWiremap={subtestResultsWiremap}
                  chartLineStyle={chartLineStyle}
                  chartMeasurement={chartMeasurement}
                  chartMeasurementUnit={chartMeasurementUnit}
                  wiremapStandard={wiremapStandard}
                  showMargin={showMargin}
                  setPreferences={setPreferences}
                  preferences={preferences}
                  subtestRes={subtestRes}
                />
              </Grid>
              <Grid container spacing={0} className={classes.thumbnailNav}>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                ></Grid>
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                >
                  <Typography
                    variant="headline"
                    component="h2"
                    className={classes.subtesttitle}
                  >
                    {translate(subtest)}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                >
                  {graphable && <Icon>insert_chart_outlined</Icon>}
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  xl={2}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                >
                  {status !== "" && subtest !== "HeadRoom" && (
                    <Button
                      mini
                      className={classes.nav}
                      onClick={this.setSubtestView}
                    >
                      <Icon>keyboard_arrow_right</Icon>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      // </Grid>
    );
  }
}

export default withStyles(styles)(ThumbnailViewer);



// WEBPACK FOOTER //
// ./src/components/common/results/thumbnails/index.js